import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { map, Observable } from 'rxjs';

import { OrderStatus } from '@fcom/common-booking';
import { QualtricsSurveys } from '@fcom/common/qualtrics/qualtrics.utils';
import { isPresent, RootPaths, unique } from '@fcom/core';
import {
  FinnairOrder,
  FinnairServiceItem,
  FinnairTotalPricesDetails,
  PaymentTransaction,
  ServiceFlow,
} from '@fcom/dapi/api/models';
import { finShare } from '@fcom/rx';
import { ButtonPosition } from '@fcom/ui-components';
import { LanguageService } from '@fcom/ui-translate';
import { getLastPaidPrices, getLastPaidServices } from '@fcom/common-booking/utils/order.utils';
import { MANAGE_BOOKING_STEPS } from '@fcom/common-booking/manage-booking-config';

import { CarTrawlerClientID } from '../../../constants';

@Component({
  selector: 'fin-mmb-purchase-success',
  templateUrl: './purchase-success.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ManageBookingPurchaseSuccessComponent implements OnInit {
  readonly OrderStatus = OrderStatus;
  readonly survey = QualtricsSurveys.MMB_FEEDBACK;
  readonly ctaUrl: string = `/${this.languageService.langValue}/${RootPaths.MANAGE_BOOKING_ROOT}/${MANAGE_BOOKING_STEPS.VIEW.path}`;
  readonly ButtonPosition = ButtonPosition;
  readonly ServiceFlow = ServiceFlow;

  @Input()
  order$: Observable<FinnairOrder>;
  @Input()
  orderStatus$: Observable<OrderStatus>;
  @Input()
  paymentMethods$: Observable<PaymentTransaction[] | undefined>;

  @Output()
  loadOrderErrorClick: EventEmitter<boolean> = new EventEmitter<boolean>();

  services$: Observable<FinnairServiceItem[]>;
  prices$: Observable<FinnairTotalPricesDetails>;
  openSurvey = false;
  pointsUsedToPay$: Observable<boolean>;
  passengerEmails$: Observable<string>;
  showCarTrawlerWidget$: Observable<boolean>;
  carTrawlerClientId = CarTrawlerClientID.MMB_ANCILLARY_CONFIRMATION_PAGE;

  constructor(private languageService: LanguageService) {}
  ngOnInit(): void {
    this.services$ = this.order$.pipe(
      map((order) => getLastPaidServices(order)),
      finShare()
    );

    this.prices$ = this.order$.pipe(
      map((order) => getLastPaidPrices(order)),
      finShare()
    );

    this.pointsUsedToPay$ = this.prices$.pipe(map((prices) => isPresent(prices?.total?.total?.totalPoints)));
    this.passengerEmails$ = this.order$.pipe(
      map((order) =>
        order.passengers
          .flatMap((pax) => pax.email || '')
          .filter(unique)
          .join(',')
      )
    );

    this.showCarTrawlerWidget$ = this.order$.pipe(
      map(
        (order) =>
          order.eligibilities?.carRental?.find((eligibility) => {
            return eligibility.id === 'JOURNEY';
          })?.isAllowedToUse
      )
    );
  }

  openModal($event: Event): void {
    $event.stopPropagation();
    this.openSurvey = true;
  }
}
